import "./LoadingView.css"
import { LoadingViewProps } from "./LoadingView.types"
import LoadWheel from "../../media/LoadWheel"

const LoadingView = (props: LoadingViewProps) => {

  const { 
    isLoading,
    showWheel = true,
    text,
    children
  } = props

  return (
    <>
      {isLoading && (
        <div className="loading-view-container">
          <video
            className="loading-hero-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/loading-hero.mp4" type="video/mp4" />
          </video>
          <div className="loading-view">
            {showWheel && <LoadWheel colour={"var(--on-primary)"} />}
            <p className="loading-text">{text}</p>

            {children !== undefined && (
              <>
              {children}
              </>
            )}
          </div>
        </div>

      )}
    </>
  )
}

export default LoadingView